<div class="header-organization-data" *ngIf="data">
  <div class="header-organization-data__name">{{data.name}}</div>
  <div class="header-organization-data__code">
    <brt-icon [icon]="'code-enter'"></brt-icon> <span>{{data.classCode}}</span>
  </div>
</div>
